import React from "react";

// Standard SVG layout icon wrapper
const IconWrapper = ({ children, active, color, ...props }) => (
  <svg
    width="28"
    height="20"
    viewBox="0 0 28 20"
    style={{
      display: "inline-block",
      verticalAlign: "middle",
      color: active ? (color || "currentColor") : "rgba(255, 255, 255, 0.6)",
      transition: "all 0.15s ease",
    }}
    {...props}
  >
    {children}
  </svg>
);

// 1: Single full chart (1x1)
export const IconSingle = ({ active, color }) => (
  <IconWrapper active={active} color={color}>
    <rect
      x="1.5"
      y="1.5"
      width="25"
      height="17"
      rx="2"
      fill={active ? "currentColor" : "none"} fillOpacity={active ? 0.18 : 0}
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </IconWrapper>
);

// 2-cols: 2 columns side by side
export const IconTwoCols = ({ active, color }) => (
  <IconWrapper active={active} color={color}>
    <rect
      x="1.5"
      y="1.5"
      width="11.5"
      height="17"
      rx="1.5"
      fill={active ? "currentColor" : "none"} fillOpacity={active ? 0.18 : 0}
      stroke="currentColor"
      strokeWidth="1.3"
    />
    <rect
      x="15"
      y="1.5"
      width="11.5"
      height="17"
      rx="1.5"
      fill={active ? "currentColor" : "none"} fillOpacity={active ? 0.18 : 0}
      stroke="currentColor"
      strokeWidth="1.3"
    />
  </IconWrapper>
);

// 2-rows: 2 rows stacked
export const IconTwoRows = ({ active, color }) => (
  <IconWrapper active={active} color={color}>
    <rect
      x="1.5"
      y="1.5"
      width="25"
      height="7.5"
      rx="1.5"
      fill={active ? "currentColor" : "none"} fillOpacity={active ? 0.18 : 0}
      stroke="currentColor"
      strokeWidth="1.3"
    />
    <rect
      x="1.5"
      y="11"
      width="25"
      height="7.5"
      rx="1.5"
      fill={active ? "currentColor" : "none"} fillOpacity={active ? 0.18 : 0}
      stroke="currentColor"
      strokeWidth="1.3"
    />
  </IconWrapper>
);

// 3-cols: 3 columns
export const IconThreeCols = ({ active, color }) => (
  <IconWrapper active={active} color={color}>
    <rect
      x="1.5"
      y="1.5"
      width="7"
      height="17"
      rx="1"
      fill={active ? "currentColor" : "none"} fillOpacity={active ? 0.18 : 0}
      stroke="currentColor"
      strokeWidth="1.2"
    />
    <rect
      x="10.5"
      y="1.5"
      width="7"
      height="17"
      rx="1"
      fill={active ? "currentColor" : "none"} fillOpacity={active ? 0.18 : 0}
      stroke="currentColor"
      strokeWidth="1.2"
    />
    <rect
      x="19.5"
      y="1.5"
      width="7"
      height="17"
      rx="1"
      fill={active ? "currentColor" : "none"} fillOpacity={active ? 0.18 : 0}
      stroke="currentColor"
      strokeWidth="1.2"
    />
  </IconWrapper>
);

// 3-rows: 3 rows
export const IconThreeRows = ({ active, color }) => (
  <IconWrapper active={active} color={color}>
    <rect
      x="1.5"
      y="1.5"
      width="25"
      height="4.5"
      rx="1"
      fill={active ? "currentColor" : "none"} fillOpacity={active ? 0.18 : 0}
      stroke="currentColor"
      strokeWidth="1.1"
    />
    <rect
      x="1.5"
      y="7.75"
      width="25"
      height="4.5"
      rx="1"
      fill={active ? "currentColor" : "none"} fillOpacity={active ? 0.18 : 0}
      stroke="currentColor"
      strokeWidth="1.1"
    />
    <rect
      x="1.5"
      y="14"
      width="25"
      height="4.5"
      rx="1"
      fill={active ? "currentColor" : "none"} fillOpacity={active ? 0.18 : 0}
      stroke="currentColor"
      strokeWidth="1.1"
    />
  </IconWrapper>
);

// 3-top-split: 1 top wide, 2 bottom
export const IconThreeTopSplit = ({ active, color }) => (
  <IconWrapper active={active} color={color}>
    <rect
      x="1.5"
      y="1.5"
      width="25"
      height="7.5"
      rx="1.5"
      fill={active ? "currentColor" : "none"} fillOpacity={active ? 0.18 : 0}
      stroke="currentColor"
      strokeWidth="1.2"
    />
    <rect
      x="1.5"
      y="11"
      width="11.5"
      height="7.5"
      rx="1.5"
      fill={active ? "currentColor" : "none"} fillOpacity={active ? 0.18 : 0}
      stroke="currentColor"
      strokeWidth="1.2"
    />
    <rect
      x="15"
      y="11"
      width="11.5"
      height="7.5"
      rx="1.5"
      fill={active ? "currentColor" : "none"} fillOpacity={active ? 0.18 : 0}
      stroke="currentColor"
      strokeWidth="1.2"
    />
  </IconWrapper>
);

// 3-bottom-split: 2 top, 1 bottom wide
export const IconThreeBottomSplit = ({ active, color }) => (
  <IconWrapper active={active} color={color}>
    <rect
      x="1.5"
      y="1.5"
      width="11.5"
      height="7.5"
      rx="1.5"
      fill={active ? "currentColor" : "none"} fillOpacity={active ? 0.18 : 0}
      stroke="currentColor"
      strokeWidth="1.2"
    />
    <rect
      x="15"
      y="1.5"
      width="11.5"
      height="7.5"
      rx="1.5"
      fill={active ? "currentColor" : "none"} fillOpacity={active ? 0.18 : 0}
      stroke="currentColor"
      strokeWidth="1.2"
    />
    <rect
      x="1.5"
      y="11"
      width="25"
      height="7.5"
      rx="1.5"
      fill={active ? "currentColor" : "none"} fillOpacity={active ? 0.18 : 0}
      stroke="currentColor"
      strokeWidth="1.2"
    />
  </IconWrapper>
);

// 4-grid: 2x2 grid
export const IconFourGrid = ({ active, color }) => (
  <IconWrapper active={active} color={color}>
    <rect
      x="1.5"
      y="1.5"
      width="11.5"
      height="7.5"
      rx="1.5"
      fill={active ? "currentColor" : "none"} fillOpacity={active ? 0.18 : 0}
      stroke="currentColor"
      strokeWidth="1.2"
    />
    <rect
      x="15"
      y="1.5"
      width="11.5"
      height="7.5"
      rx="1.5"
      fill={active ? "currentColor" : "none"} fillOpacity={active ? 0.18 : 0}
      stroke="currentColor"
      strokeWidth="1.2"
    />
    <rect
      x="1.5"
      y="11"
      width="11.5"
      height="7.5"
      rx="1.5"
      fill={active ? "currentColor" : "none"} fillOpacity={active ? 0.18 : 0}
      stroke="currentColor"
      strokeWidth="1.2"
    />
    <rect
      x="15"
      y="11"
      width="11.5"
      height="7.5"
      rx="1.5"
      fill={active ? "currentColor" : "none"} fillOpacity={active ? 0.18 : 0}
      stroke="currentColor"
      strokeWidth="1.2"
    />
  </IconWrapper>
);

// 4-cols: 4 columns
export const IconFourCols = ({ active, color }) => (
  <IconWrapper active={active} color={color}>
    <rect
      x="1.5"
      y="1.5"
      width="5"
      height="17"
      rx="1"
      fill={active ? "currentColor" : "none"} fillOpacity={active ? 0.18 : 0}
      stroke="currentColor"
      strokeWidth="1.1"
    />
    <rect
      x="8"
      y="1.5"
      width="5"
      height="17"
      rx="1"
      fill={active ? "currentColor" : "none"} fillOpacity={active ? 0.18 : 0}
      stroke="currentColor"
      strokeWidth="1.1"
    />
    <rect
      x="14.5"
      y="1.5"
      width="5"
      height="17"
      rx="1"
      fill={active ? "currentColor" : "none"} fillOpacity={active ? 0.18 : 0}
      stroke="currentColor"
      strokeWidth="1.1"
    />
    <rect
      x="21"
      y="1.5"
      width="5"
      height="17"
      rx="1"
      fill={active ? "currentColor" : "none"} fillOpacity={active ? 0.18 : 0}
      stroke="currentColor"
      strokeWidth="1.1"
    />
  </IconWrapper>
);

// 4-left-main: 1 left large, 3 right stacked
export const IconFourLeftMain = ({ active, color }) => (
  <IconWrapper active={active} color={color}>
    <rect
      x="1.5"
      y="1.5"
      width="14"
      height="17"
      rx="1.5"
      fill={active ? "currentColor" : "none"} fillOpacity={active ? 0.18 : 0}
      stroke="currentColor"
      strokeWidth="1.2"
    />
    <rect
      x="17.5"
      y="1.5"
      width="9"
      height="4.5"
      rx="1"
      fill={active ? "currentColor" : "none"} fillOpacity={active ? 0.18 : 0}
      stroke="currentColor"
      strokeWidth="1"
    />
    <rect
      x="17.5"
      y="7.75"
      width="9"
      height="4.5"
      rx="1"
      fill={active ? "currentColor" : "none"} fillOpacity={active ? 0.18 : 0}
      stroke="currentColor"
      strokeWidth="1"
    />
    <rect
      x="17.5"
      y="14"
      width="9"
      height="4.5"
      rx="1"
      fill={active ? "currentColor" : "none"} fillOpacity={active ? 0.18 : 0}
      stroke="currentColor"
      strokeWidth="1"
    />
  </IconWrapper>
);

// 4-top-main: 1 top large, 3 bottom columns
export const IconFourTopMain = ({ active, color }) => (
  <IconWrapper active={active} color={color}>
    <rect
      x="1.5"
      y="1.5"
      width="25"
      height="8.5"
      rx="1.5"
      fill={active ? "currentColor" : "none"} fillOpacity={active ? 0.18 : 0}
      stroke="currentColor"
      strokeWidth="1.2"
    />
    <rect
      x="1.5"
      y="12"
      width="7"
      height="6.5"
      rx="1"
      fill={active ? "currentColor" : "none"} fillOpacity={active ? 0.18 : 0}
      stroke="currentColor"
      strokeWidth="1"
    />
    <rect
      x="10.5"
      y="12"
      width="7"
      height="6.5"
      rx="1"
      fill={active ? "currentColor" : "none"} fillOpacity={active ? 0.18 : 0}
      stroke="currentColor"
      strokeWidth="1"
    />
    <rect
      x="19.5"
      y="12"
      width="7"
      height="6.5"
      rx="1"
      fill={active ? "currentColor" : "none"} fillOpacity={active ? 0.18 : 0}
      stroke="currentColor"
      strokeWidth="1"
    />
  </IconWrapper>
);

// Helper to return the corresponding icon for a layout key
export const getLayoutIcon = (layoutKey, active = false, color) => {
  switch (layoutKey) {
    case "1":
      return <IconSingle active={active} color={color} />;
    case "2-cols":
      return <IconTwoCols active={active} color={color} />;
    case "2-rows":
      return <IconTwoRows active={active} color={color} />;
    case "3-cols":
      return <IconThreeCols active={active} color={color} />;
    case "3-rows":
      return <IconThreeRows active={active} color={color} />;
    case "3-top-split":
      return <IconThreeTopSplit active={active} color={color} />;
    case "3-bottom-split":
      return <IconThreeBottomSplit active={active} color={color} />;
    case "4-grid":
      return <IconFourGrid active={active} color={color} />;
    case "4-cols":
      return <IconFourCols active={active} color={color} />;
    case "4-left-main":
      return <IconFourLeftMain active={active} color={color} />;
    case "4-top-main":
      return <IconFourTopMain active={active} color={color} />;
    default:
      return <IconSingle active={active} color={color} />;
  }
};
